module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-10 col-md-9 mobile-menu-container"
  }, [_c('nav', [_c('ul', [_vm._l((_vm.$root.config.header_nav_links), function(link) {
    return (!_vm.$root.checkingOut) ? _c('li', [_c('a', {
      attrs: {
        "href": link.location
      }
    }, [_vm._v(_vm._s(link.title))])]) : _vm._e()
  }), _vm._v(" "), (_vm.$root.checkingOut) ? _c('li', {
    staticClass: "buttons"
  }, [_c('a', {
    class: {
      'no-background': _vm.$root.checkingOut
    },
    attrs: {
      "href": 'tel:' + _vm.$root.locale.global.telephone
    },
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_call_us_on)
    }
  })]) : _vm._e(), _vm._v(" "), (this.$root.authenticated) ? _c('li', {
    staticClass: "buttons"
  }, [_c('router-link', {
    class: {
      'no-background': _vm.$root.checkingOut
    },
    attrs: {
      "to": {
        name: 'account.overview'
      }
    }
  }, [_vm._v("My Account")])], 1) : _vm._e(), _vm._v(" "), (this.$root.authenticated) ? _c('li', {
    staticClass: "buttons"
  }, [_c('a', {
    class: {
      'no-background': _vm.$root.checkingOut
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _c('li', {
    staticClass: "buttons"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_vm._v("Login or Sign up")])], 1)], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'cart.basket'
      },
      "id": "cart"
    }
  }, [_c('span', {
    staticClass: "fa fa-shopping-basket hidden-xs"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.number_of_items_in_basket))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f036997"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/AuthHeader.vue
// module id = 184
// module chunks = 0